module.exports = __webpack_public_path__ + "img/sha_05.5919e513.jpg";